import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid jkanban-container" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexKanbanBoard',
  setup(__props) {

const DefaultDemo = defineAsyncComponent(() => import("@/components/theme/kanbanboard/DefaultDemo.vue"))
const CustomDome = defineAsyncComponent(() => import("@/components/theme/kanbanboard/CustomDome.vue"))
const ApiDome = defineAsyncComponent(() => import("@/components/theme/kanbanboard/ApiDome.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "App",
      mains: "Kanbar Board",
      title: "Kanbar Board"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DefaultDemo)),
        _createVNode(_unref(CustomDome)),
        _createVNode(_unref(ApiDome))
      ])
    ])
  ], 64))
}
}

})